<template>
  <router-view/>
</template>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
}
body {
  font-family: Arial, sans-serif;
 
}
ul{
  list-style: none;
}
</style>
